<template>
    <b-container fluid>
      <div class="row">
        <div class="col-md-12">
          <div class="iq-card">
            <div class="content">
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validation_yjsdocs_name">{{cvPayTransactionIdLabel}}</label>
                  <input
                    v-model="vmPayrefFromData.pay_tid"
                    type="text"
                    class="form-control"
                    required
                  />
                </div>
                <div class="col-md-12 mb-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118'">
                  <label for="validation_yjsdocs_tags">{{cvPayTransactionRefundLabel}}</label>
                  <textarea
                    v-model="vmPayrefFromData.notes"
                    type="text textarea"
                    class="form-control"
                    required
                  ></textarea>
                </div>
              </div>
              <div class="form-group">
                <button type="button" class="btn btn-primary" @click="refundPayment()">{{cvSubmitBtn}}</button>
              </div>
                <div class="form-group">
                  <span class="mt-2 primary-color"><i>
                    Note 1: This action does not initiate refund on the payment gateway. Actual refund has to be initiated from the payment gateway (Ex. Razorpay)<br>
                    Note 2: This action sets the PAYMENT on GIDE to REFUND state and disables the paid serivice on GIDE.AI
                  </i></span>
                </div>
            </form>
            </div>
          </div>
        </div>
      </div>
    </b-container>
  </template>

<script>
import { socialvue } from "../../config/pluginInit"
import ApiResponse from "../../Utils/apiResponse.js"
import { PayTransactionss } from "../../FackApi/api/PayTransactions"

export default {
  name: "paymentRefund",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propPayTransactionsRefundObj: {
      type: Object,
      default: function () {
        return {
          "pay_tid": "",
          "pay_order_id": "",
          "pay_status_code": "",
          "pay_status_desc": "",
          "pay_amount": "",
          "pay_amount_usd": "",
          "pay_currency": "",
          "pay_tax": "",
          "pay_subs_id": "",
          "pay_user_bill_id": "",
          "pay_params": ""
        }
      }
    }
  },
  data: () => ({
    cvPayTransactionIdLabel: "Pay Transaction Id",
    cvPayTransactionRefundLabel: "Refund notes",
    cvSubmitBtn: "Submit",
    vmPayrefFromData: {}
  }),
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  mounted () {
    this.payTransactionsView()
    socialvue.index()
  },
  methods: {
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmPayrefFromData) {
          if (!this.vmPayrefFromData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
        return null
      }
    },
    /**
     * payTransactionsView
     */
    async payTransactionsView () {
      try {
        if (this.propOpenedInModal) {
          this.vmPayrefFromData = this.propPayTransactionsRefundObj
        }
        else {
          let payTransactionsId = this.$route.params.pay_id
          let payTransactionsViewResp = await PayTransactionss.payTransactionsView(this, payTransactionsId)
          if (payTransactionsViewResp && payTransactionsViewResp.resp_status) {
            this.vmPayrefFromData = payTransactionsViewResp.resp_data.data
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at payTransactionsView() and Exception:", err.message)
      }
    },
    /**
     * payTransactionsEdit
     */
    async refundPayment () {
      try {
        // if (!this.validate()) {
        //   return false
        // }
        this.cvLoadingStatus = true

        const finalNotes = `
          User ID: ${this.userData.user_id}
          User Name: ${this.userData.user_name}
          User Email: ${this.userData.user_email}
          Notes: ${this.vmPayrefFromData.notes}`.trim()

        let refundpayload = {
          "refund": {
            "entity": {
              "notes": {
                "comment": finalNotes
              },
              "payment_id": this.vmPayrefFromData.pay_tid
            }
          }
        }
        let payload = {
          "event": "refund.processed",
          "isTest": "1", // Means init by Admin
          "payload": await (JSON.stringify(refundpayload))
        }

        // this.vmPayrefFromData.payload.refund.entity.notes.comment = `${this.vmPayrefFromData.notes}`

        let payTransactionsRefundResp = await PayTransactionss.razorpay_listeners(this, payload)
        await ApiResponse.responseMessageDisplay(this, payTransactionsRefundResp)
        if (payTransactionsRefundResp.status && payTransactionsRefundResp.status !== "ok") {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseRazorpayListenerstModal", this.payload)
        }
      }
      catch (err) {
        console.error("Exception occurred at payTransactionsEdit() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>

  <style lang="scss" scoped>
  .content h1{
    font-weight: 600;
    font-size: 37px;
    text-align: center;
  }

  p{
    text-align: center;
    color: var(--iq-title-text);
    font-size: 14px;
    font-weight: 500;
  }
  </style>
